// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { toggleModal } from '../../storage/actions/modalsActions';
import getContractorGroups from '../../utils/api/get/getContractorGroups';
import deleteGroup from '../../utils/api/delete/deleteGroup';
import { reloadData } from '../../storage/actions/applicationStateActions';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';
import RowActions from '../../components/dashboard/RowActions';

const ContractorGroups = ({
  mainContainer, toggleModal, isReload, reloadData,
}) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    fetchGroups();
  }, [isReload]);

  const fetchGroups = async () => {
    toggleModal(true, 'loader');

    const data = await getContractorGroups();

    setGroups(data);
    toggleModal(false, 'loader');
  };

  const openEditGroupModal = (groupId) => {
    toggleModal(true, 'addOrEditGroups', false, { id: groupId });
  };

  const openAddGroupModal = () => {
    toggleModal(true, 'addOrEditGroups');
  };

  const onDeleteGroup = (groupId, name) => {
    toggleModal(true, 'confirmModal', true, {
      onAccept() {
        deleteGroup(groupId).then(() => reloadData());
      },
      header: `Delete ${name || 'team'}?`,
      buttonLabels: {
        reject: 'Cancel',
        confirm: 'Delete',
      },
    });
  };

  return (
    <div className="subpage-wrap">
      <div className="subpage-header">
        <h1 className="subpage-title">Preferred Contractor Groups</h1>
        <button className="subpage-btn subpage-btn--gold" type="button" aria-label="Add group" onClick={openAddGroupModal}>
          <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
          Add group
        </button>
      </div>

      <div className="subpage-table-scroll">
        <table className="subpage-table">
          <thead>
            <tr>
              <th>Group name</th>
              <th>Members</th>
              <th style={{ textAlign: 'right' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {groups.map(group => {
              const { name, _id, groupUsersCount } = group;
              return (
                <tr key={_id}>
                  <td>
                    <span
                      className="row-name cursor_pointer"
                      role="button"
                      tabIndex={0}
                      onClick={() => openEditGroupModal(_id, name)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') openEditGroupModal(_id, name);
                      }}
                    >
                      {name}
                    </span>
                  </td>
                  <td>{groupUsersCount}</td>
                  <td>
                    <RowActions
                      alignEnd
                      onEdit={(e) => {
                        e.preventDefault();
                        openEditGroupModal(_id, name);
                      }}
                      onDelete={(e) => {
                        e.preventDefault();
                        onDeleteGroup(_id, name);
                      }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  reloadData,
};

const mapStateToProps = state => ({
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractorGroups);
